// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__cUT6h","header":"Messages_header__v-6j8"};